import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'src/Hooks';

type ThemeProviderProps = {
	children: React.ReactElement;
};

/** Компонента подключает указанные стили */
const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
	const { t } = useTranslation();
	const [] = useTheme('light');

	useEffect(() => {
		import(`../../public/Themes/${t('theme')}/style.css`);
	}, [t]);

	return children;
};

export default ThemeProvider;
